
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widgets/[widgetId]",
      function () {
        return require("private-next-pages/widgets/[widgetId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widgets/[widgetId]"])
      });
    }
  